<template>
	<div class="address-edit" @click="analysisFocus = false">
		<el-dialog :title="title" :visible.sync="isShow" v-if="isCreate" :before-close="onClose" :close-on-click-modal="false" center width="860px" :append-to-body="true">
			<el-form ref="addrobj" :model="addrobj" @submit.native.prevent>
				<el-form-item>
					<div @click.stop="analysisFocus = true" class="analysis-row" :class="{'analysis-focus': analysisFocus}">
						<label>{{ $t('trade.AddressEdit.721046-0') }}</label>
						<el-input type="textarea" class="analysis-address" v-model="analysisAddress" autosize :placeholder="$t('trade.AddressEdit.721046-1')"></el-input>
						<div class="analysis-btn" v-show="analysisFocus">
							<el-button @click.stop="analysisAddress = ''" size="small" plain>{{ $t('common.action.clear') }}</el-button>
							<el-button type="danger" @click="confirmAnalysis" size="small" plain>{{ $t('trade.AddressEdit.721046-3') }}</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item>
					<el-row >
						<el-col :span="12">
							<el-input v-model="addrobj.name" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-4')" maxlength="50" show-word-limit @input="inputChange">
							</el-input>
						</el-col>
						<el-col :span="5" style="margin-left:20px;" v-if="!isFromTradeDetail">
							<el-select v-model="addrobj.telArea" style="width:100%;" :placeholder="$t('common.prompt.select')">
								<el-option
								v-for="item in telAreaList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								<span>{{ item.label}}{{ item.tel }}</span>
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="6" v-if="!isFromTradeDetail">
							<el-input v-model="addrobj.tel" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-5')" @input="inputChange">
							</el-input>
						</el-col>
						<el-col :span="12" v-if="isFromTradeDetail">
							<el-input v-model="addrobj.tel" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-5')" @input="inputChange">
							</el-input>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item :class='cantShowForeignAdrSelect ? `adr-sel-form_nopadding` : `adr-sel-form`'>
					<div v-if='!isForeignAdr' class="address-region-row">
						<div class="region-select-wrap">
							<el-select v-model="selectedProvince" filterable :placeholder="$t('trade.AddressEdit.721046-6')" class="region-select" @change="handleProvinceChange">
								<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="region-select-wrap">
							<el-select v-model="selectedCity" filterable :placeholder="$t('trade.AddressEdit.721046-7')" class="region-select" @change="handleCityChange">
								<el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="region-select-wrap">
							<el-select v-model="selectedDistrict" filterable :placeholder="$t('trade.AddressEdit.721046-8')" class="region-select" @change="handleDistrictChange">
								<el-option v-for="item in districtOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="region-select-wrap">
							<el-select v-model="selectedStreet" filterable clearable :placeholder="$t('trade.AddressEdit.721046-9')" @change="handleStreetChange" class="region-select">
								<el-option v-for="item in streetOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
					<el-cascader filterable v-else size="large" :options="countryList" v-model="selectedCountry" :placeholder="$t('common.CheckInApply.459127-2')">
					</el-cascader>
					<div v-if='!cantShowForeignAdrSelect || isForeignAdr' class='adr-type-btn' @click="changeAdrType">{{ isForeignAdr ? $t('common.CheckInApply.459127-3') : $t('common.CheckInApply.459127-4') }}</div>
				</el-form-item>
				<el-form-item v-if='isForeignAdr'>
					<div style="display: flex;">
						<el-input class="input-item" v-model="addrobj.district" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-13')" maxlength="50"></el-input>
						<el-input class="input-item" v-model="addrobj.city" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-14')" maxlength="50"></el-input>
						<el-input class="input-item" v-model="addrobj.province" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-15')" maxlength="50"></el-input>
					</div>
				</el-form-item>
				<el-form-item>
					<el-input v-model="addrobj.address" autocomplete="off" :placeholder="$t('common.CheckInApply.459127-5')" maxlength="250" show-word-limit></el-input>
				</el-form-item>
				<el-form-item v-if='isForeignAdr && !isFromTradeDetail'>
					<el-input v-model="addrobj.zipCode" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-17')" maxlength="250"></el-input>
				</el-form-item>
				<el-form-item v-if="!isFromTradeDetail">
					<el-checkbox v-model="isDefault" @change="checkboxChange">{{ $t('trade.AddressEdit.721046-18') }}</el-checkbox>
				</el-form-item>
				<div v-if="isMustIDCard && (isNeedDeliveryIdInfoWithoutBondGoods || isFromTradeConfirmWithBondGoods)">
					<el-form-item>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-select v-model="addrobj.idCardType" :placeholder="$t('common.prompt.select')">
									<el-option v-for='item in ["身份证", "学生证", "军官证", "护照", "港澳通行证"]' :key="item" :label="getCardTypeLabel(item)" :value="item" @change="handleCardtypeChange">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="12">
								<el-input v-model="addrobj.idCardName" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-19')" @input="inputChange">
								</el-input>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item>
						<el-input v-model="addrobj.idCard" autocomplete="off" :placeholder="$t('trade.AddressEdit.721046-20')" maxlength="250" @input="inputChange"></el-input>
					</el-form-item>
				</div>
				<div v-if="isMustIDCard && (isNeedDeliveryIdInfoWithoutBondGoods || isFromTradeConfirmWithBondGoods)" class="flex-row" style="justify-content: space-around;">
					<div>
						<el-upload accept=".jpg,.jpeg,.png" :action="config.uploadFileUrl" :show-file-list="false" :data="frontImgUploadData" :on-preview="_handlePictureCardPreview" :on-success="_handleFrondSuccess">
							<el-image v-if="frontSideImageUrl" :src="frontSideImageUrl" class="upload-img">
								<div slot="error" class="image-slot" style="margin-top: 35px">
									<i class="el-icon-camera gray"></i>
									<div class="gray img-text">{{ $t('trade.AddressEdit.721046-21') }}</div>
								</div>
							</el-image>
							<div v-else>
								<i class="el-icon-camera gray"></i>
								<div class="gray img-text">{{ $t('trade.AddressEdit.721046-21') }}</div>
							</div>
						</el-upload>
						<div class="upload-text">
							（{{ $t('trade.tradeconfirm.047740-0') }}）
						</div>
					</div>

					<div>
						<el-upload accept=".jpg,.jpeg,.png" :action="config.uploadFileUrl" :data="endImgUploadData" :show-file-list="false" :on-preview="_handlePictureCardPreview" :on-success="_handleReverseSuccess">
							<el-image v-if="reverseSideImageUrl" :src="reverseSideImageUrl" class="upload-img">
								<div slot="error" class="image-slot" style="margin-top: 35px">
									<i class="el-icon-camera gray"></i>
									<div class="gray img-text">{{ $t('trade.AddressEdit.721046-23') }}</div>
								</div>
							</el-image>
							<div v-else>
								<i class="el-icon-camera gray"></i>
								<div class="gray img-text">{{ $t('trade.AddressEdit.721046-23') }}</div>
							</div>
						</el-upload>
						<div class="upload-text">
							（{{ $t('trade.tradeconfirm.047740-0') }}）
						</div>
					</div>
				</div>


			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onClose">{{ $t('common.action.cancel') }}</el-button>
				<el-button type="danger" v-if="!isFromTradeDetail" @click="onSave">{{ $t('trade.AddressEdit.721046-25') }}</el-button>
				<el-button type="danger" v-else @click="tradeDetailAddressSave">{{ $t('trade.AddressEdit.721046-25') }}</el-button>

			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		config
	} from '../../config.js'
	import {
		getParam
	} from '../../utils/api-utils/api-params.js'
	import {
		callFeignV1
	} from '../../utils/api-utils/api-callFeign.js'
	import addressUtils from '../../utils/api-utils/api-address.js'
	import adressUtils from '../../utils/api-utils/api-address.js'
	import {
		chinaAreaJson,
		chinaAreaJsonFlat
	} from '../../utils/chinaareajson.js'

	// 身份证号验证正则
	const regIdNo = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
	// 身份证姓名正则
	const regInputName = /[\u4E00-\u9FA5]{1,10}(·[\u4E00-\u9FA5]{2,10}){0,2}/;
	const regSaveName = /[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}/;
	const specialfilter = /((?!女士|先生|男士).)*/;

	import {
		// regionData,
		// provinceAn,
		// regionDataPlus,
		// dCityDataPlus,
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
	export default {
		name: "address-edit",
		props: {
			title: {
				type: String,
				default: ''
			},
			addressinfo: {
				type: Object,
				default: function() {
					return {};
				}
			},
			isCreate: {
				type: Boolean,
				default: false
			},
			isShow: {
				type: Boolean,
				default: false
			},
			isFromTradeDetail: {
				type: Boolean,
				default: false
			},
			isFromTradeConfirmWithBondGoods: {
				type: Boolean,
				default: false
			},
		},
		watch: {
			//监听父组件传值
			addressinfo(newValue, oldValue) {

			},
		},
		data() {
			return {
				addrobj: {},
				options: chinaAreaJson,
				selectedProvince: '',
				selectedCity: '',
				selectedDistrict: '',
				streetOptions: [{
					label: this.$t("trade.AddressEdit.721046-51"),
					value: '0'
				}],
				selectedStreet: '0',
				isDefault: false,
				analysisAddress: '', //待解析地址
				analysisFocus: false, //解析地址获得焦点
				isForeignAdr: false, // 是否展示国外地址
				countryList: [],
				selectedCountry: [], // 当前国家
				config: config, //获取url参数
				reverseSideImageUrl: "", // 证件正面url
				frontSideImageUrl: "", // 证件反面url
				isMustIDCard: false, // 是否必传身份证件
				isNeedDeliveryIdInfoWithoutBondGoods: true,
				tradeIsHaveBondedGoods: false,
				cantShowForeignAdrSelect: false,
				telAreaList: [
					{
						value: 0,
						tel:' +86',
						label: this.$t('trade.AddressEdit.721046-41')
					},
					{
						value: 1,
						tel:' +852',
						label: this.$t('trade.AddressEdit.721046-42')
					},
					{
						value: 2,
						tel:' +853',
						label: this.$t('trade.AddressEdit.721046-43')
					},
					{
						value: 3,
						tel:' +886',
						label: this.$t('trade.AddressEdit.721046-44')
					},
					{
						value: 4,
						tel:' ',
						label: this.$t('trade.AddressEdit.721046-45')
					},
				],
			}
		},
		mounted() {
			console.log('this.addressinfo',this.addressinfo);
			this.addrobj = this.addressinfo;
			this.addrobj.telArea = Number(this.addressinfo.telArea)||0;
			// 反填地址信息
			this._setAddressInfo();

			// 加载国家列表
			this._loadCountryList();
			this._getParam();
		},
		computed: {
			provinceOptions() {
				return this.options || [];
			},
			cityOptions() {
				let province = (this.options || []).find(item => item.value === this.selectedProvince);
				return province && province.children ? province.children : [];
			},
			districtOptions() {
				let city = this.cityOptions.find(item => item.value === this.selectedCity);
				return city && city.children ? city.children : [];
			},
			userName() {
				return localStorage.getItem('SubMemberName') || localStorage.getItem('JackyunUserName')
			},
			dateTime() {
				return new Date().getTime();
			},
			frontImgUploadData() {
				return {
					userName: this.userName,
					fileClass: 'idCardImg',
					fileName: this.addrobj.idCard + "-0.png"
				}
			},
			endImgUploadData() {
				return {
					userName: this.userName,
					fileClass: 'idCardImg',
					fileName: this.addrobj.idCard + "-1.png"
				}
			}
		},
		methods: {
			_extraCodeToText(code) {
				let matchItem = chinaAreaJsonFlat.find(item => item.value == code);
				return matchItem && matchItem.label
			},
			_setAddressInfo() {
				// 新增情况，文本框输入会异常监听，排除异常监听
				let keys = Object.keys(this.addressinfo);

				// 新增情况：addressinfo 为空对象（无任何 key）或只有 addressId 但 isFromTradeDetail 为 false
				let isNewAddress = keys.length === 0 || (!keys.includes('addressId') && !this.isFromTradeDetail);

				// 新增情况：初始化 addrobj 并设置默认值
				if (isNewAddress) {
					this.addrobj = {
						telArea: 0
					};
					return;
				}

				// 初始化地址对象
				this.addrobj = JSON.parse(JSON.stringify(this.addressinfo));

				// 订单详情修改地址 直接返回
				if (this.isFromTradeDetail) {
					this._setAddressInfoFromTradeDetail();
					return;
				}

				// 渲染地址编辑数据
				if (this.addrobj.addressId) {
					this._getRegionCode();
					this.isDefault = this.addrobj.isDefault;

					// 检测是否为海外地址
					if (this.addrobj.country && this.addrobj.country != '中国') {
						this.isForeignAdr = true;
						this.selectedCountry = [this.addrobj.country];
					} else {
						// 回显解析得到的地址
						this._showAnalysisAdr(this.addrobj.province, this.addrobj.city, this.addrobj.district);
						this.$set(this.addrobj, 'town', this.addrobj.town || '');
						this.$nextTick(() => {
							this.loadStreetOptions(true);
						});
					}
				} else {
					this.isDefault = false;
					this.isForeignAdr = false;
					this.selectedCountry = [];
				}

				if (!this.addrobj.idCardType) {
					this.addrobj.idCardType = "身份证"
				}

				// 时间戳
				let d = new Date().getTime();
				// 正面图判断
				if (this.addrobj.idCard) {
					this.frontSideImageUrl = `https://jkyun--jmall.oss-cn-hangzhou.aliyuncs.com/jmc/jmallFile/${this.userName}/idCardImg/${this.addrobj.idCard}-0.png?v=${d}`;
					this.reverseSideImageUrl = `https://jkyun--jmall.oss-cn-hangzhou.aliyuncs.com/jmc/jmallFile/${this.userName}/idCardImg/${this.addrobj.idCard}-1.png?v=${d}`;
				} else {
					this.frontSideImageUrl = "";
					this.reverseSideImageUrl = "";
				}

				this.analysisAddress = '';
			},

			onClose() {
				// 清空数据
				this.addrobj = {};
				this.addrobj.telArea = 0;
				this.selectedCountry = [];
				this.selectedProvince = '';
				this.selectedCity = '';
				this.selectedDistrict = '';
				this.resetStreetOptions();

				this.$emit('close');
			},
			handleProvinceChange(value) {
				let province = this.provinceOptions.find(item => item.value === value);
				this.selectedCity = '';
				this.selectedDistrict = '';
				this.addrobj.province = province ? province.label : '';
				this.addrobj.city = '';
				this.addrobj.district = '';
				this.resetStreetOptions();
			},
			handleCityChange(value) {
				let city = this.cityOptions.find(item => item.value === value);
				let province = this.provinceOptions.find(item => item.value === this.selectedProvince);
				this.selectedDistrict = '';
				this.addrobj.province = province ? province.label : '';
				this.addrobj.city = city ? this._getCityText(this.addrobj.province, city.label) : '';
				this.addrobj.district = '';
				this.resetStreetOptions();
			},
			handleDistrictChange(value) {
				let province = this.provinceOptions.find(item => item.value === this.selectedProvince);
				let city = this.cityOptions.find(item => item.value === this.selectedCity);
				let district = this.districtOptions.find(item => item.value === value);
				this.addrobj.province = province ? province.label : '';
				this.addrobj.city = city ? this._getCityText(this.addrobj.province, city.label) : '';
				this.addrobj.district = district ? district.label : '';
				this.resetStreetOptions();
				if (value) {
					this.loadStreetOptions(true);
				}
			},
			handleStreetChange(value) {
				let streetName = this.getStreetLabelByValue(value);
				this.$set(this.addrobj, 'town', streetName === this.$t("trade.AddressEdit.721046-51") ? '' : streetName);
			},
			resetStreetOptions() {
				this.streetOptions = [{
					label: this.$t("trade.AddressEdit.721046-51"),
					value: '0'
				}];
				this.selectedStreet = '0';
				this.$set(this.addrobj, 'town', '');
			},
			getStreetLabelByValue(value) {
				let target = this.streetOptions.find(item => item.value === value);
				return target ? target.label : this.$t("trade.AddressEdit.721046-51");
			},
			async loadStreetOptions(force = false) {
				if (this.isForeignAdr || !this.selectedDistrict) {
					this.resetStreetOptions();
					return;
				}
				let districtCode = this.selectedDistrict;
				let provinceName = this.addrobj.province || '';
				let cityName = this.addrobj.city || '';
				let districtName = this.addrobj.district || '';
				let currentStreet = this.addrobj.town || '';
				if (!force && this.streetOptions.length > 1) {
					return;
				}
				this.streetOptions = [{
					label: this.$t("trade.AddressEdit.721046-51"),
					value: '0'
				}];
				this.selectedStreet = '0';
				try {
					let response = await callFeignV1('erp.districtchina.getsubdistrictlist', {
						jsonStr: JSON.stringify({
							adcode: districtCode,
							provinceName,
							cityName,
							districtName
						})
					});
					let streetList = [];
					if (Array.isArray(response)) {
						streetList = response;
					} else if (Array.isArray(response && response.result && response.result.data)) {
						streetList = response.result.data;
					} else if (Array.isArray(response && response.result && response.result.data && response.result.data.result && response.result.data.result.data)) {
						streetList = response.result.data.result.data;
					} else if (Array.isArray(response && response.data && response.data.result && response.data.result.data)) {
						streetList = response.data.result.data;
					}
					this.streetOptions = [{
						label: this.$t("trade.AddressEdit.721046-51"),
						value: '0'
					}].concat(streetList.map(item => ({
						label: item.name,
						value: String(item.adcode || item.id || item.code || '')
					})).filter(item => item.value));
					let targetOption = this.streetOptions.find(item => item.label === currentStreet || item.value === currentStreet);
					this.selectedStreet = targetOption ? targetOption.value : '0';
					this.$set(this.addrobj, 'town', targetOption ? targetOption.label : '');
				} catch (e) {
					this.resetStreetOptions();
				}
			},
			/**
			 * 证件类型选项显示名
			 * @param {String} item
			 */
			getCardTypeLabel(item) {
				const labelMap = {
					"身份证": this.$t("trade.AddressEdit.721046-46"),
					"学生证": this.$t("trade.AddressEdit.721046-47"),
					"军官证": this.$t("trade.AddressEdit.721046-48"),
					"护照": this.$t("trade.AddressEdit.721046-49"),
					"港澳通行证": this.$t("trade.AddressEdit.721046-50")
				};
				return labelMap[item] || item;
			},
			/**
			 * 证件选择切换
			 * @param {Object} value
			 */
			handleCardtypeChange(value) {
				this.addrobj.cardtpye = value;
			},
			inputChange() {
				// 保持当前区域选择，不做额外处理
			},

			checkboxChange(value) {
				this.isDefault = value;
			},
			async onSave() {
				if (!this._checkData()) {
					return;
				}

				// 计算当前地址的经纬度
				let receiverLocation = await this._getLocationByAddress();

				let country = '中国';
				// 海外地址需要清空省市区-》（保留省市区）
				if (this.isForeignAdr) {
					country = this.selectedCountry[0];
					// this.addrobj.province = '';
					// this.addrobj.city = '';
					// this.addrobj.district = '';
				}

				this.customerId = localStorage.getItem("pc_customerId");
				let obj = {
					customerId: this.customerId,
					addressId: this.addrobj.addressId,
					name: this.addrobj.name,
					tel: this.addrobj.tel,
					country: country,
					province: this.addrobj.province,
					city: this.addrobj.city,
					district: this.addrobj.district,
					town: this.addrobj.town || '',
					address: this.addrobj.address,
					isDefault: this.isDefault ? 1 : 0,
					latitude: receiverLocation.latitude,
					longitude: receiverLocation.longitude,
					idCardType: this.addrobj.idCardType,
					idCardName: this.addrobj.idCardName,
					idCard: this.addrobj.idCard,
					zipCode: this.addrobj.zipCode,
					telArea: this.addrobj.telArea,
				};
				this.$request.jackyunPost({
					method: "jmall.address.setaddressinfo",
					jsonStr: JSON.stringify(obj)
				}, (res) => {
					if (res.code == 200) {
						this.$message({
							message: this.$t('trade.AddressEdit.721046-26'),
							type: 'success'
						});
						// 补充地址Id
						if (!obj.addressId) {
							obj.addressId = res.result.data;
						}
						this.$emit('success', obj);
					} else {
						this.$message.error(this.$t('trade.AddressEdit.721046-27'));
					}
				});
			},

			//校验数据
			_checkData() {
				//关闭所有警告
				this.$message.closeAll();
				if (!this.addrobj.name) {
					this.$message.error(this.$t('trade.AddressEdit.721046-28'));
					return false;
				}
				if (!this.addrobj.tel) {
					this.$message.error(this.$t('trade.AddressEdit.721046-29'));
					return false;
				}
				const regTel = /^1[3-9]\d{9}(-\d{1,5})?$/;
				const regLandline = /^0\d{2,3}-?\d{7,8}$/; // 座机号：区号(3-4位)-电话号码(7-8位)
				const otherRegTel = /^\d{6,20}$/;
				const otherAreaTel = /^[\d\-]{6,20}$/; // 其他地区手机号：支持数字和连字符
				if(!this.isFromTradeDetail){
					if(this.addrobj.telArea==0){
						if(!regTel.test(this.addrobj.tel) && !regLandline.test(this.addrobj.tel)){
							this.$message.error(this.$t('trade.AddressEdit.721046-30'));
							return false;
						}
					}else if(this.addrobj.telArea==4){
						// 其他地区：支持数字和连字符
						if(!otherAreaTel.test(this.addrobj.tel)){
							this.$message.error(this.$t('trade.AddressEdit.721046-30'));
							return false;
						}
					}else{
						if(!otherRegTel.test(this.addrobj.tel)){
							this.$message.error(this.$t('trade.AddressEdit.721046-30'));
							return false;
						}
					}
				}
				// 国外地址也需要校验省市
				if (this.isForeignAdr && this.selectedCountry.length == 0) {
					this.$message.error(this.$t('trade.AddressEdit.721046-31'));
					return false;
				}

				if (this.isForeignAdr && !this.addrobj.zipCode) {
					this.$message.error(this.$t('trade.AddressEdit.721046-32'));
					return false;
				}
				if (!this.addrobj.province || this.addrobj.province == '全部') {
					this.$message.error(this.$t(this.isForeignAdr ? 'trade.AddressEdit.721046-15' : 'trade.AddressEdit.721046-6'));
					return false;
				}
				if (!this.addrobj.city || this.addrobj.city == '全部') {
					this.$message.error(this.$t(this.isForeignAdr ? 'trade.AddressEdit.721046-14' : 'trade.AddressEdit.721046-7'));
					return false;
				}
				if (!this.addrobj.district || this.addrobj.district == '全部') {
					this.$message.error(this.$t(this.isForeignAdr ? 'trade.AddressEdit.721046-13' : 'trade.AddressEdit.721046-8'));
					return false;
				}

				if (!this.addrobj.address) {
					this.$message.error(this.$t('trade.AddressEdit.721046-33'));
					return false;
				}

				// 是否开启证件号必填检测
				if (this.isNeedDeliveryIdInfoWithoutBondGoods || this.isFromTradeConfirmWithBondGoods) {
					if (!this.isMustIDCard) {
						return true
					}


					// 证件名称检测
					if (!this.addrobj.idCardName) {
						this.$message.error(this.$t('trade.AddressEdit.721046-19'));
						return false;
					}

					if (!regSaveName.test(this.addrobj.idCardName)) {
						this.$message.error(this.$t('trade.AddressEdit.721046-34'));
						return false;
					}
					// 证件号检测
					if (!this.addrobj.idCard) {
						this.$message.error(this.$t('trade.AddressEdit.721046-35'));
						return false;
					}

					// 证件格式检测
					if (this.addrobj.idCardType == '身份证' && !regIdNo.test(this.addrobj.idCard)) {
						this.$message.error(this.$t('trade.AddressEdit.721046-36'));
						return false;
					}
				}
				return true;
			},

			//读取配置参数
			async _getParam() {
				let paramList = await getParam("isMustIDCard,isNeedDeliveryIdInfoWithoutBondGoods,cantShowForeignAdrSelect");
				this.isMustIDCard = !this.isFromTradeDetail && paramList.isMustIDCard == "1";
				this.isNeedDeliveryIdInfoWithoutBondGoods = paramList.isNeedDeliveryIdInfoWithoutBondGoods == "1";
				this.cantShowForeignAdrSelect = paramList.cantShowForeignAdrSelect == "1";
				
			},

			/**
			 * 获取经纬度
			 */
			async _getLocationByAddress() {
				// 获取收件地址完整地址
				let fullAddress = "";
				if (this.isForeignAdr) {
					fullAddress = this.selectedCountry[0] + this.addrobj.province + this.addrobj.city + this.addrobj.district + this.addrobj.address;
				} else {
					fullAddress = this.addrobj.province + this.addrobj.city + this.addrobj.district + (this.addrobj.town || '') + this.addrobj.address;
				}

				// 计算收货地址的经纬度
				let receiverLocation = await adressUtils.getLocationByAddress(fullAddress);
				return receiverLocation;
			},

			//获取对应的地址编码
			_getRegionCode() {
				let address = this.addrobj;
				let cityName = address.city;
				let specialCity = "北京市，天津市，上海市，重庆市"; //直辖市
				if (address.province && specialCity.indexOf(address.province) > -1) {
					cityName = '市辖区';
					if (address.province == "重庆市" && address.city == "县") {
						cityName = '县';
					}
				}
				let province = "";
				let city = "";
				let district = "";
				try {
					province = TextToCode[address.province].code;
					city = TextToCode[address.province][cityName].code;
					district = TextToCode[address.province][cityName][address.district].code;
				} catch (e) {}

				this.selectedProvince = province;
				this.selectedCity = city;
				this.selectedDistrict = district;
			},
			//编码转文字
			_getCityText(province, city) {
				let cityName = city;
				let specialCity = "北京市，天津市，上海市，重庆市"; //直辖市
				if (province && specialCity.indexOf(province) > -1) {
					cityName = province;
					if (province == "重庆市" && city == "县") {
						cityName = '县';
					}
				}
				return cityName;
			},
			//地址解析
			async confirmAnalysis() {
				if (!this.analysisAddress) {
					this.$message.error(this.$t('trade.AddressEdit.721046-37'));
					return;
				}

				this.selectedProvince = '';
				this.selectedCity = '';
				this.selectedDistrict = '';
				this.resetStreetOptions();

				let address = await addressUtils.addressrAnalyze(this.analysisAddress);

				this.$set(this.addrobj, 'tel', address.mobile || '');
				this.$set(this.addrobj, 'name', address.receiverName || '');
				this.$set(this.addrobj, 'province', address.state || '');
				this.$set(this.addrobj, 'city', address.city || '');
				this.$set(this.addrobj, 'district', address.district || '');
				this.$set(this.addrobj, 'town', '');
				this.$set(this.addrobj, 'address', (address.town || '') + (address.address || ''));
				this.$set(this.addrobj, 'telArea', 0);
				// 回显解析得到的地址
				this._showAnalysisAdr(this.addrobj.province, this.addrobj.city, this.addrobj.district);
				// 省市区回显
				this._getRegionCode();
				this.analysisFocus = false;
				this.isForeignAdr = false;
			},
			/**
			 * 切换地址
			 */
			changeAdrType() {
				this.isForeignAdr = !this.isForeignAdr;
				delete this.addrobj.province
				delete this.addrobj.city
				delete this.addrobj.district
				delete this.addrobj.address
				// this.addrobj.province = '';
				// this.addrobj.city = '';
				// this.addrobj.district = '';
				// this.addrobj.address = '';
			},

			/**
			 * 加载国家列表
			 */
			async _loadCountryList() {
				// 优先缓存中数据
				let countryList = localStorage.getItem("countryList");

				if (countryList && countryList != '[]') {
					return this.countryList = JSON.parse(countryList);
				}

				countryList = await addressUtils.getCountryList();
				// 渲染到页面并添加到缓存
				this.countryList = countryList;
			},

			/**
			 * 附件上传
			 */
			_handlePictureCardPreview(response, file, fileList) {
				let aa = file
			},

			_handleFrondSuccess(response, file, fileList) {
				if (response.error_code == "0") {
					this.frontSideImageUrl = response.error_info;
				}
			},
			_handleReverseSuccess(response, file, fileList) {
				if (response.error_code == "0") {
					this.reverseSideImageUrl = response.error_info;
				}
			},

			/**
			 * 省市区完整回显
			 * @param {Object} province
			 * @param {Object} city
			 * @param {Object} district
			 */
			_showAnalysisAdr(province, city, district) {
				let _this = this;
				setTimeout(function() {
					_this.addrobj.province = province;
					_this.addrobj.city = city;
					_this.addrobj.district = district;
					_this._getRegionCode();
				}, 100);
			},

			/**
			 * 订单详情修改地址 反填信息
			 */
			_setAddressInfoFromTradeDetail() {
				// 检测是否为海外地址
				if (this.addrobj.country && this.addrobj.country != '中国') {
					this.isForeignAdr = true;
					this.selectedCountry = [this.addrobj.country];
				} else {
					// 回显解析得到的地址
					this._showAnalysisAdr(this.addrobj.province, this.addrobj.city, this.addrobj.district);
					this.$set(this.addrobj, 'town', this.addrobj.town || '');
					// 省市区回显
					this._getRegionCode();
					if (this.addrobj.town) {
						this.$nextTick(() => {
							this.loadStreetOptions(true);
						});
					}
				}
			},

			/**
			 * 订单详情修改地址 保存
			 */
			tradeDetailAddressSave() {
				if (!this.addrobj.name) {
					return this.$message.error(this.$t('trade.AddressEdit.721046-38'));
				}

				if (!this.addrobj.tel) {
					return this.$message.error(this.$t('trade.AddressEdit.721046-39'));
				}
				// const regTel = /^1[3-9]\d{9}$/;
				// if(!regTel.test(this.addrobj.tel)){
				// 	return this.$message.error("电话号码填写错误");
				// }
				if (!this.addrobj.address) {
					return this.$message.error(this.$t('trade.AddressEdit.721046-40'));
				}

				let addressInfo = {
					sendTo: this.addrobj.name,
					tel: this.addrobj.tel,
					country: this.isForeignAdr ? this.selectedCountry[0] : "中国",
					province: this.addrobj.province,
					city: this.addrobj.city,
					district: this.addrobj.district,
					town: this.addrobj.town || "",
					address: this.addrobj.address,
					// zipCode: this.addrobj.zipCode,
					buyerType: 1,
					isForeignAdr: this.isForeignAdr,
					telArea: this.addrobj.telArea||0,
				};
				this.$emit('success', addressInfo);
			},


		}
	}
</script>

<style scoped="scoped">
	.address-region-row {
		display: flex;
		align-items: center;
		gap: 12px;
		flex: 1 1 auto;
		min-width: 0;
		/* overflow-x: auto; */
	}

	.region-select-wrap {
		min-width: 0;
		flex: 1 1 0;
	}

	.region-select {
		width: 100%;
	}

	::v-deep .region-select .el-input,
	::v-deep .region-select .el-input__inner {
		width: 100%;
	}

	.analysis-row {
		border: solid 1px #dcdfe6;
		background-color: #f9f9f9;
		border-radius: 5px;
		padding: 15px 15px 15px 0;
		line-height: 25px;
	}

	.analysis-row label {
		margin-left: 15px;
		color: #f56b6b;
	}

	::v-deep .analysis-address textarea {
		background-color: #f9f9f9;
		border: none;
		resize: none;
	}

	.analysis-row.analysis-focus {
		background-color: #fff;
	}

	::v-deep .analysis-row.analysis-focus .analysis-address textarea {
		background-color: #fff;
	}

	.analysis-btn {
		display: flex;
		justify-content: flex-end;
		margin: 10px 0 0 10px;
	}

	.el-cascader {
		width: auto;
		flex: 1 1 auto;
		min-width: 0;
	}

	/* .el-select {
		width: 160px;
	} */

	.adr-sel-form {
		padding-right: 60px;
		position: relative;
	}
	
	.adr-sel-form_nopadding{
		position: relative;
	}

	.adr-sel-form /deep/ .el-form-item__content,
	.adr-sel-form_nopadding /deep/ .el-form-item__content {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.adr-type-btn {
		font-size: 12px;
		flex: 0 0 auto;
		white-space: nowrap;
		cursor: pointer;
	}

	.upload-img {
		height: 100px;
		width: 150px;
	}

	.el-icon-camera {
		font-size: 30px;
	}

	.upload-text {
		text-align: center;
		color: #ccc;
	}

	.image-slot {
		margin-top: 38px;
	}

	.gray {
		color: #ccc;
	}

	.img-text {
		margin-top: 5px;
	}

	.input-item {
		margin-right: 10px;
	}

	.input-item:last-child {
		margin-right: unset;
	}
</style>